import angular from 'angular';

/* @ngInject */
export default function AllDefinitionsCacheService($q, DefinitionApiService, DefinitionParameterRangeApiService) {
    let allDefinitions = undefined;

    /**
     *
     * We have to use a Promise object here. Angular has a $q object that represents a Promise obj, but it would require
     * refactoring to use here (requires $rootScope). see https://code.angularjs.org/1.2.29/docs/api/ng/service/$q
     * Since the call to DefinitionAPIService is asynchronous it's too early to return the variable allDefinitions.
     * Therefore, we move it out to a promise object. More on that here: https://docs.angularjs.org/api/ng/service/$q
     */
    return {
        getAllDefinitions: function () {
            let deferred = $q.defer();

            if (allDefinitions) {
                deferred.resolve(allDefinitions);
            } else {
                DefinitionApiService.getAllDefinitions(function (definitions) {
                    allDefinitions = [];
                    for (var i = 0; i < definitions.length; ++i) {
                        allDefinitions.push(definitions[i]);
                    }
                    deferred.resolve(allDefinitions);
                }, function (error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        },
        setDefinitionParamRange: function (definitions) {
            const definitionIds = [];

            if (definitions !== undefined) {

                if (definitions.constructor === Array) {
                    angular.forEach(definitions, function (definition) {
                        definitionIds.push(definition.id);
                    });
                } else if (definitions.childDefinitions.length > 0) {
                    angular.forEach(definitions.childDefinitions, function (definition) {
                        definitionIds.push(definition.id);
                    });
                } else {
                    definitionIds.push(definitions.id);
                }

                DefinitionParameterRangeApiService.getDefinitionParameterRanges(definitionIds, 'COMPONENT_EDGE_TILE', function (ranges) {
                    var defs;

                    if (definitions.constructor === Array) {
                        defs = definitions;
                    } else {
                        defs = definitions.childDefinitions;
                    }
                    angular.forEach(defs, function (value, key) {
                        if (this[key].id === ranges[key].definitionId) {
                            this[key].range = ranges[key].parameterRanges;
                        }
                    }, defs);
                });
            }
        },
    };
}
